export const baseUrl = process.env.REACT_APP_NODE_ENV === 'development' ? 'https://abladmin.bigmove.dev/api/v1' : 'https://onlinebankingadmin.accessbankliberia.com/api/v1';
export const ablBaseUrl = process.env.REACT_APP_NODE_ENV === 'development' ? 'https://tapi.accessbank.com.lr/API' : 'https://jkapi.accessbank.com.lr/API';
export const proxyUrl = 'https://cors-anywhere.herokuapp.com/'; 

export const domain = process.env.REACT_APP_NODE_ENV === 'development' ? '@accessbanktest.net' : "@accessbank.com.lr";
